@import url("../../global/global.css");
:host {
  --accordion-border-radius: 8px;
  --accordion-padding: 24px;
}

/* Default styles */
.dc-accordion {
  box-shadow: var(--dc-primary-box-shadow);
  display: flex;
  flex-direction: column;
  position: relative;
}

.dc-accordion-heading {
  background-color: var(--dc-background-colour);
  border: 0;
  color: var(--dc-primary-text-color);
  cursor: pointer;
  font-family: var(--dc-font-family);
  font-size: 18px;
  font-weight: 600;
  padding: var(--accordion-padding) var(--accordion-padding) 0;
}

@media (--breakpoint-tablet) {
  .dc-accordion-heading {
    font-size: 24px;
  }
}

.dc-accordion-heading-content {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--accordion-padding);
}

.dc-accordion-chevron {
  width: 24px;
}

.dc-accordion-chevron path {
  fill: var(--dc-primary-text-color);
}

.dc-accordion-content {
  color: var(--dc-primary-text-color);
  display: none;
  font-family: var(--dc-font-family);
  font-size: 16px;
  padding: var(--accordion-padding);
}

/* Hover state styles */
.dc-accordion-heading:hover {
  background-color: var(--dc-ui-fill-hover-colour);
}

/* Focus state styles */
.dc-accordion-heading:focus {
  outline: 3px solid var(--dc-primary-colour);
  z-index: 1;
}

/* Styles to render correct border-radius when multiple accordion items are present */
:host(:first-child) .dc-accordion,
:host(:first-child) .dc-accordion-heading {
  border-top-left-radius: var(--accordion-border-radius);
  border-top-right-radius: var(--accordion-border-radius);
}

:host(:last-child) .dc-accordion,
:host(:last-child) .dc-accordion-heading {
  border-bottom-left-radius: var(--accordion-border-radius);
  border-bottom-right-radius: var(--accordion-border-radius);
}

:host(:last-child) .expand .dc-accordion-heading {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* Expanded state styles */
.expand .dc-accordion-heading-content {
  border-bottom: 1px solid var(--dc-ui-border-default);
}

.expand .dc-accordion-chevron {
  transform: rotate(180deg);
}

.expand .dc-accordion-content {
  display: flex;
}

/* Disabled state styles */
.disabled .dc-accordion-heading:hover {
  background-color: var(--dc-background-colour);
  cursor: default;
}

.disabled .dc-accordion-heading-content {
  color: var(--dc-secondary-disabled-text-colour);
}

.disabled .dc-accordion-chevron path {
  fill: var(--dc-secondary-disabled-text-colour);
}
